import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';
import Pill from '../../../../library/pill/pill';

import './cms-article-list.scss';

function CmsArticleList(props) {
  const { articles } = props;

  return (
    <div styleName="container">
      {Array.isArray(articles) &&
        articles.map((article, idx) => {
          const { category, image, info, link, title } = article;
          return (
            <article key={`cal-${idx}`} styleName="article">
              <Link to={link?.href}>
                <div
                  style={{ backgroundImage: `url(${image?.url})` }}
                  styleName="image"
                >
                  <Pill styleName="category">{category}</Pill>
                </div>

                <div styleName="summary">
                  <h4 styleName="title">{title}</h4>
                  <p styleName="info">{info}</p>
                </div>
              </Link>
            </article>
          );
        })}
    </div>
  );
}

CmsArticleList.propTypes = {
  articles: PropTypes.array
};

export default CmsArticleList;
